import React, { useContext } from "react";

import { trans } from "@cortexglobal/rla-intl";
import { InputField } from "@cortexglobal/rla-components";

import SurveySubmissionContext from "../SurveySubmissionContext";

const AnswerText = ({ answer, readonly }) => {
    const { surveySystem, handleAnswerChange } = useContext(
        SurveySubmissionContext
    );

    return (
        <InputField
            name={answer.question_uuid}
            onChange={(e) => handleAnswerChange(e.name, e.value)}
            disabled={!!readonly}
            value={answer.answer}
            error={surveySystem.questionErrors[answer.question_uuid]}
        />
    );
};

export default AnswerText;
